"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dompurify_1 = require("dompurify");

var injectTrackingPixel = function injectTrackingPixel(tags) {
  if (tags === void 0) {
    tags = [];
  }

  tags.forEach(function (tag) {
    var _a;

    var el = document.createElement('html');
    tag = tag.replace('%%CACHEBUSTER%%', Date.now().toString());
    el.innerHTML = dompurify_1.sanitize(tag);
    var pixel = el.querySelector('img');

    if (pixel) {
      (_a = document === null || document === void 0 ? void 0 : document.querySelector('head')) === null || _a === void 0 ? void 0 : _a.appendChild(pixel);
    }
  });
};

exports.default = injectTrackingPixel;